import store from '../../index';

export default abstract class DataStoreService {
  private namespace: string = ''

  constructor(namespace: string) {
    this.namespace = namespace;
  }

  protected dispatch(actionName: string, payload?: any): Promise<any> {
    return store.dispatch(`${this.namespace}/${actionName}`, payload)
  }
}


// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/services/classes/dataStoreService.ts